import { render } from "./infoUpdateList.vue?vue&type=template&id=5d670ba0&scoped=true"
import script from "./infoUpdateList.vue?vue&type=script&lang=js"
export * from "./infoUpdateList.vue?vue&type=script&lang=js"

import "./infoUpdateList.vue?vue&type=style&index=0&id=5d670ba0&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d670ba0"]])

export default __exports__